var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCredit = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 41 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Finance \xE2\x80\xA2 \xF0\x9F\x92\xB5/credit-card"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon Artwork",
    d: "M28.9665 15.5H11.3665V13.25H28.9665V15.5ZM28.9665 26.75H11.3665V20H28.9665V26.75ZM28.9665 11H11.3665C10.1455 11 9.1665 12.0013 9.1665 13.25V26.75C9.1665 27.3467 9.39829 27.919 9.81087 28.341C10.2234 28.7629 10.783 29 11.3665 29H28.9665C29.55 29 30.1096 28.7629 30.5221 28.341C30.9347 27.919 31.1665 27.3467 31.1665 26.75V13.25C31.1665 12.0013 30.1765 11 28.9665 11Z",
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCredit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/credit.fedac6b7.svg";
export { ForwardRef as ReactComponent };